module.exports = __webpack_public_path__ + "img/shop-banner.6de79ac8.jpg";